// extracted by mini-css-extract-plugin
export var avatarContainer = "_43-0";
export var gray = "_43-f";
export var green = "_43-c";
export var icon = "_43-9";
export var image = "_43-1";
export var lg = "_43-6";
export var md = "_43-5";
export var presenceDot = "_43-b";
export var red = "_43-d";
export var sm = "_43-4";
export var status = "_43-a";
export var xl = "_43-7";
export var xs = "_43-3";
export var xxl = "_43-8";
export var xxs = "_43-2";
export var yellow = "_43-e";